import React from 'react';

const ArchivedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="20px"
    viewBox="0 0 16 20"
    fill="currentColor"
  >
    <g id="surface1">
      <path d="M 13.5 1.5 L 2.5 1.5 C 1.671875 1.5 1 2.171875 1 3 L 1 4.5 C 1 5.132812 1.402344 5.699219 2 5.910156 L 2 13 C 2 13.828125 2.671875 14.5 3.5 14.5 L 12.5 14.5 C 13.328125 14.5 14 13.828125 14 13 L 14 5.910156 C 14.597656 5.699219 15 5.132812 15 4.5 L 15 3 C 15 2.171875 14.328125 1.5 13.5 1.5 Z M 13 13 C 13 13.277344 12.777344 13.5 12.5 13.5 L 3.5 13.5 C 3.222656 13.5 3 13.277344 3 13 L 3 6 L 13 6 Z M 14 4.5 C 14 4.777344 13.777344 5 13.5 5 L 2.5 5 C 2.222656 5 2 4.777344 2 4.5 L 2 3 C 2 2.722656 2.222656 2.5 2.5 2.5 L 13.5 2.5 C 13.777344 2.5 14 2.722656 14 3 Z M 14 4.5" />
      <path d="M 6.5 8.5 L 9.5 8.5 C 9.777344 8.5 10 8.277344 10 8 C 10 7.722656 9.777344 7.5 9.5 7.5 L 6.5 7.5 C 6.222656 7.5 6 7.722656 6 8 C 6 8.277344 6.222656 8.5 6.5 8.5 Z M 6.5 8.5" />
    </g>
  </svg>
);

export default ArchivedIcon;
